exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-local-customers__action-button {\n  float: right;\n}\n", ""]);

// exports
